/**
 * The words of paying toward the Team Budget at registration: the deposit, or any
 * amount up to the whole team fee. SN-8441 / SN-8442 — a rep who chooses to pay is
 * registered once the payment goes through; Not now registers without paying.
 * Labels are Title-Cased at render (capitalizeWords); sentences are used as-is.
 */
export const TEAM_BUDGET_PAYMENT_COPY = {
  choiceTitle: 'Pay Toward Your Team Fee',
  choiceIntro:
    'What you pay now comes out of the team fee and counts toward the Minimum To Qualify; your team is registered as soon as the payment goes through. Or choose Not now: the fee is split and invoiced to your players.',
  optionDeposit: 'Pay the deposit now',
  optionDepositDetail: (deposit: string) => `${deposit} plus tax.`,
  optionCustom: 'Pay a different amount',
  optionCustomDetail: (minimum: string, teamFee: string) =>
    `Any amount from ${minimum} up to the full team fee of ${teamFee}, plus tax.`,
  optionLater: 'Not now',
  optionLaterDetail:
    'Complete your registration now and pay from your Team Budget later.',
  customFieldLabel: 'Amount to pay now',
  submitLater: 'COMPLETE REGISTRATION',
  depositRowLabel: 'Deposit (Minimum To Qualify)',
  pricing: 'Getting your payment ready…',
  registeredOncePaid: 'Your team is registered once the payment goes through.',
  headingSubtitle:
    'Pay toward your team fee now — your team is registered once the payment goes through — or complete your registration and pay from your Team Budget later.',
  payUnavailable:
    "Paying at registration isn't available right now. Choose Not now to complete your registration — you can pay from your Team Budget.",
  lockedTitle: 'Your Payment Is Being Processed',
  locked:
    "A payment was already taken for this registration. Please don't pay again — your registration completes once it clears. Contact support if it doesn't.",
  outdated:
    'This page is out of date. Reload it to complete your registration.',
  reload: 'RELOAD',
  retry: "We couldn't update your payment. Try again in a moment.",
  tryAgain: 'TRY AGAIN',
  capturedTitle: 'Payment Received',
  captured:
    "Your payment was received. We're finishing your registration — please don't pay again.",
  needsReview:
    "Your payment was received, but it can't be applied automatically. Please don't pay again — support will contact you.",
  receivedTitle: 'Payment Received',
  received:
    "Payment received — support will review how it's applied to your Team Budget.",
  payNow: 'PAY NOW',
  continuePayment: 'CONTINUE PAYMENT',
} as const
